import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import axios from 'src/utils/axios';
import { Grid, Button, Backdrop, CircularProgress, Snackbar, Typography, Divider, IconButton, CardContent, Tooltip } from '@mui/material';
import Card from '@mui/material/Card';
import { DataGrid } from '@mui/x-data-grid';
import Alert from 'src/components/Alert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import moment from 'moment';

const styles = {
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  }),
  card: {
    width: '100%',
    height: '100%'
  },
  tableHeadCell: {
    border: '1px solid #ddd',
    color: '#fff',
    backgroundColor: '#0033a0'
  },
  tableCell: {
    textAlign: 'center',
    border: '1px solid #00000050'
  },
  coloredText: {
    textAlign: 'center'
  },
  InputGrid: {
    border: '1px solid #ccc',
    padding: '2px',
    width: '40%',
    margin: '2rem auto'
  },
  Box: {
    backgroundColor: '#0033a0'
  }
};

function DynamicServiceDetail() {
  const navigate = useNavigate();

  const { UserCode, ElType, ElCode, UserElCode, Description } = useParams();

  const [
    serviceLaborMaterialGeneralDetailData,
    setServiceLaborMaterialGeneralDetailData
  ] = React.useState([]);
  const [
    serviceLaborMaterialIncludeListData,
    setServiceLaborMaterialIncludeListData
  ] = React.useState([]);
  const [selectedRowInclude, setSelectedRowsInclude] = React.useState([]);
  const [selectedRowExclude, setSelectedRowsExclude] = React.useState([]);
  const [stockNumberInput, setStockNumberInput] = React.useState('');

  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    getDynamicServiceLaborMaterialDetailData();
    getDynamicServiceLaborMaterialIncludeListData();
  }, []);

  const getDynamicServiceLaborMaterialDetailData = () => {
    setLoading(true);
    axios
      .get(
        `GetDynamicServiceLaborMaterialDetail/${UserCode}/${ElType}/${ElCode}`
      )
      .then(response => {
        const data = response.data;
        setServiceLaborMaterialGeneralDetailData(data);
        setLoading(false);
      });
  };

  const getDynamicServiceLaborMaterialIncludeListData = () => {
    setLoading(true);
    let stockNumber = stockNumberInput.length > 0 ? stockNumberInput : '-';

    axios
      .get(
        `GetDynamicServiceLaborMaterialIncludeList/${UserCode}/${ElCode}/${ElType}/${stockNumber}`
      )
      .then(response => {
        const data = response.data;
        setServiceLaborMaterialIncludeListData(data);
        setLoading(false);
      });
  };

  const handleInsertOrDeleteSelectedRows = ActionType => {
    var data = [];
    var updatedRows = [];

    setLoading(true);

    if (ActionType === 1) {
      updatedRows = selectedRowInclude.map(row => {
        return {
          ALT_EL1_KODU: row.EL1_KODU,
          ALT_EL1_TIPI: row.EL1_TIPI,
          ALT_KUL_KODU: row.KUL_KODU,
          ActionType: ActionType,
          UST_KUL_KODU: UserCode,
          UST_EL1_TIPI: ElType,
          UST_EL1_KODU: ElCode
        };
      });
    } else {
      updatedRows = selectedRowExclude.map(row => {
        return { ...row, ActionType: ActionType };
      });
    }
    updatedRows.forEach(row => {
      data.push(row);
    });

    let message = ActionType === 1 ? 'Ekleme' : 'Silme';

    axios
      .post('/DynamicServiceLaborMaterialInsertDeleteSelectedData', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        if (response.data.ErrorCode == 0) {
          setresponseMessage(`${message} İşlemi başarıyla gerçekleşmiştir.`);
          setUyariTip('success');

          getDynamicServiceLaborMaterialDetailData();
          getDynamicServiceLaborMaterialIncludeListData();
        } else {
          setresponseMessage(response.data.ErrorDescription);
          setUyariTip('error');
        }

        setLoading(false);
        setUyari(true);

        setSelectedRowsExclude([]);
        setSelectedRowsInclude([]);
      });
  };

  const columnsOfExcludedList = [
    { field: 'KUL_EL1_KODU', headerName: 'Kod', width: 300 },
    { field: 'ACIKLAMA', headerName: 'Açıklama', width: 400 },
    { field: 'EL1_TIPI_ACIKLAMA', headerName: 'Tip', width: 300 },
    { field: 'MALZEME_SINIFI', headerName: 'Malzeme Sınıfı', width: 300 },
    { field: 'KULLANICI', headerName: 'Ekleyen Kullanıcı', width: 175 },
    {
      field: 'EKLENME_TARIHI',
      headerName: 'Eklenme Tarihi',
      width: 250,
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  const columnsOfIncludedList = [
    { field: 'KUL_EL1_KODU', headerName: 'Kod', width: 300 },
    { field: 'ACIKLAMA', headerName: 'Açıklama', width: 400 },
    { field: 'EL1_TIPI_ACIKLAMA', headerName: 'Tip', width: 350 },
    { field: 'MALZEME_SINIF', headerName: 'Malzeme Sınıfı', width: 350 },
    { field: 'KULLANICI', headerName: 'Ekleyen Kullanıcı', width: 350 },
    {
      field: 'TARIH',
      headerName: 'Eklenme Tarihi',
      width: 250,
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={2000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card style={styles.card}>
        <CardContent>
          <Grid container>
            <Grid container alignItems="center">
              <Grid size={3}>
                <Tooltip title="Geri Dön">
                  <IconButton
                    onClick={() => {
                      handleGoBack();
                    }}
                  >
                    <ArrowBackIcon style={{ color: '#FF9800' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid size={6}>
                <Typography
                  variant="h3"
                  align="center"
                  style={{ color: '#FF9800' }}
                >
                  {`${decodeURIComponent(UserElCode)} - ${decodeURIComponent(Description)}`}
                </Typography>
              </Grid>
              <Grid size={3} />
            </Grid>
            <Grid size={12}>
              <Divider variant="middle" />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 1,
                lg: 1
              }} />
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 10,
                lg: 10
              }}>
              <DataGrid
                rows={serviceLaborMaterialGeneralDetailData || []}
                columns={columnsOfExcludedList}
                getRowId={rows => rows.KUL_EL1_KODU}
                checkboxSelection
                onSelectionModelChange={newSelection => {
                  const selectedRowsData = newSelection.map(id =>
                    serviceLaborMaterialGeneralDetailData.find(
                      row => row.KUL_EL1_KODU === id
                    )
                  );
                  setSelectedRowsExclude(selectedRowsData);
                }}
                selectionModel={selectedRowExclude.map(row => row.KUL_EL1_KODU)}
                style={{ height: 600 }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 1,
                lg: 1
              }} />
          </Grid>
          <br />
          <br />
          <Grid container spacing={1}>
            <Grid size={5} />
            <Grid size={2}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="medium"
                onClick={() => {
                  handleInsertOrDeleteSelectedRows(2);
                }}
              >
                SEÇİLİ OLANLARI SİL
              </Button>
            </Grid>
            <Grid size={5} />
          </Grid>
          <br />
          <br />
          <Grid container>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 1,
                lg: 1
              }} />
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 10,
                lg: 10
              }}>
              <DataGrid
                rows={serviceLaborMaterialIncludeListData || []}
                columns={columnsOfIncludedList}
                getRowId={rows => rows.KUL_EL1_KODU}
                checkboxSelection
                onSelectionModelChange={newSelection => {
                  const selectedRowsData = newSelection.map(id =>
                    serviceLaborMaterialIncludeListData.find(
                      row => row.KUL_EL1_KODU === id
                    )
                  );
                  setSelectedRowsInclude(selectedRowsData);
                }}
                selectionModel={selectedRowInclude.map(row => row.KUL_EL1_KODU)}
                style={{ height: 600 }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 1,
                lg: 1
              }} />
            <Grid container spacing={1}>
              <Grid size={5} />
              <Grid size={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  size="medium"
                  onClick={() => {
                    handleInsertOrDeleteSelectedRows(1);
                  }}
                >
                  SEÇİLİ OLANLARI EKLE
                </Button>
              </Grid>
              <Grid size={5} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default DynamicServiceDetail;
